import type { DefaultRootState } from "react-redux";
import type { Dispatch } from "redux";
import type { ThunkAction } from "redux-thunk";
import { getNetSalesReportData } from "interfaces/reports/net_sales";

import type { IDateRange } from "types/dates";
import type INetSales from "types/reports/net_sales";
import { RequestStatus } from "types/request";

export type NetSalesActionTypes =
  | IRequestNetSalesAction
  | IReceiveNetSalesAction
  | IOtherAction;

type ThunkResult<R> = ThunkAction<
  R,
  DefaultRootState,
  undefined,
  NetSalesActionTypes
>;

export enum NetSalesTypeKeys {
  REQUEST_NET_SALES_DATA = "REPORTS/NET_SALES/REQUEST_NET_SALES_DATA",
  RECEIVE_NET_SALES_DATA = "REPORTS/NET_SALES/RECEIVE_NET_SALES_DATA",
  OTHER_ACTION = "REPORTS/NET_SALES/__any_other_action_type__",
}

export interface IReceiveNetSalesAction {
  type: NetSalesTypeKeys.RECEIVE_NET_SALES_DATA;
  netSales: INetSales[];
  netSalesRequestStatus: RequestStatus;
}

export const receiveNetSalesData = (
  netSales: INetSales[]
): IReceiveNetSalesAction => {
  return {
    type: NetSalesTypeKeys.RECEIVE_NET_SALES_DATA,
    netSales,
    netSalesRequestStatus: RequestStatus.SUCCESS,
  };
};

export interface IRequestNetSalesAction {
  type: NetSalesTypeKeys.REQUEST_NET_SALES_DATA;
  netSalesRequestStatus: RequestStatus;
}

export const requestNetSales = (): IRequestNetSalesAction => ({
  type: NetSalesTypeKeys.REQUEST_NET_SALES_DATA,
  netSalesRequestStatus: RequestStatus.REQUESTING,
});

export const fetchNetSales = (dateRange: IDateRange): ThunkResult<void> => {
  return (dispatch: Dispatch<any>): Promise<any> | void => {
    dispatch(requestNetSales());
    if (GD_PROJECT_ID) {
      return getNetSalesReportData(dateRange).then((netSales) => {
        dispatch(receiveNetSalesData(netSales));
      });
    }
  };
};

export interface IOtherAction {
  type: NetSalesTypeKeys.OTHER_ACTION;
}
